"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAROUSEL_DOCUMENTS_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.CAROUSEL_DOCUMENTS_QUERY = (0, client_1.gql) `
  query getCarouselDocuments($propertyId: ID!) {
    property(propertyId: $propertyId) {
      id
      streetViewEnabled
      coverImageDocumentUploadId
      documentUploads(filterProcessing: true, carouselDocumentsOnly: true) {
        id
        accountDocumentType {
          id
          name
        }
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q2Fyb3VzZWxEb2N1bWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0FkZHJlc3NQYW5lbC9Qcm9wZXJ0eU92ZXJ2aWV3L19fcXVlcmllc19fL2dldENhcm91c2VsRG9jdW1lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDJDQUFxQztBQUV4QixRQUFBLHdCQUF3QixHQUFHLElBQUEsWUFBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Q0FlMUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGdxbCB9IGZyb20gXCJAYXBvbGxvL2NsaWVudFwiO1xuXG5leHBvcnQgY29uc3QgQ0FST1VTRUxfRE9DVU1FTlRTX1FVRVJZID0gZ3FsYFxuICBxdWVyeSBnZXRDYXJvdXNlbERvY3VtZW50cygkcHJvcGVydHlJZDogSUQhKSB7XG4gICAgcHJvcGVydHkocHJvcGVydHlJZDogJHByb3BlcnR5SWQpIHtcbiAgICAgIGlkXG4gICAgICBzdHJlZXRWaWV3RW5hYmxlZFxuICAgICAgY292ZXJJbWFnZURvY3VtZW50VXBsb2FkSWRcbiAgICAgIGRvY3VtZW50VXBsb2FkcyhmaWx0ZXJQcm9jZXNzaW5nOiB0cnVlLCBjYXJvdXNlbERvY3VtZW50c09ubHk6IHRydWUpIHtcbiAgICAgICAgaWRcbiAgICAgICAgYWNjb3VudERvY3VtZW50VHlwZSB7XG4gICAgICAgICAgaWRcbiAgICAgICAgICBuYW1lXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbmA7XG4iXX0=